export default __webpack_public_path__ + "resources/icons/n121-0ab4.png";